export default class BitField
{
	constructor(initial)
	{
		try
		{
			this.value = initial.valueOf();
		}
		catch(e){}

		this.value = this.value || 0;
	}

	// bits start at 0 as the far right and least significant bit

	testBit(n)
	{
		/*
			2 ^ 0 = 1 = 0b00000001
			2 ^ 1 = 2 = 0b00000010
			2 ^ 2 = 4 = 0b00000100
			etc
		*/

		n = Math.pow(2,n);
		return !!(this.value & n);
	}

	setBit(n)
	{
		n = Math.pow(2,n);
		this.value |= n;
		return this;
	}

	clearBit(n)
	{
		n = Math.pow(2,n);
		this.value &= ~n;
		return this;
	}


	mask(n,invert)
	{
		/*
			not inverting
			------------------------------------
			 set all but last 3 bits to 0
			------------------------------------

			  0b11111111 mask 3
			= 0b11111111 mask 0b00000111
			= 0b00000111

			inverting
			------------------------------------
			 set last 3 bits to 0
			------------------------------------

			  0b11111111 mask 3 w/ invert
			= 0b11111111 mask 0b11111000
			= 0b11111000
		*/

		n = Math.pow(2,n) - 1;
		this.value &= invert?~n:n;
		return this;
	}

	valueOf()
	{
		return this.value;
	}
};